import { transformAskOrMidPriceFn } from '../../../../bonds';
import { useSecuritiesSecurityTransformApi } from '../api';

export const useSecuritiesSecurityAskOrMidPrice = () => {
  const response = useSecuritiesSecurityTransformApi(transformAskOrMidPriceFn);
  return response;
};
